import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import Clear from 'material-ui/svg-icons/content/clear';
import Done from 'material-ui/svg-icons/action/done';
import { red300, lightGreen500 } from 'material-ui/styles/colors';
import 'react-table/react-table.css';
import { getTranslate } from 'react-localize-redux';
import { translate } from 'react-i18next';

import { dateFromISO } from '../utils/helpers';
import CommonTable from '../components/CommonTable';
import TextFilterField from '../components/filters/TextFilterField';
import YesNoFilterField from '../components/filters/YesNoFilterField';
import DateRangeFilterField from '../components/filters/DateRangeFilterField';
import * as accountActions from '../redux/modules/accounts';
import EnumSelectFilterField from '../components/filters/EnumSelectFilterField';
import { ACCOUNT_ROLE_ENUMS } from '../config';
import i18n from '../translations/i18n';
/*
PropTypes / DefaultProps
 */
const defaultProps = {
  loading: false,
  accounts: {},
};

const propTypes = {
  loading: PropTypes.bool,
  accounts: PropTypes.object,
  fetchAccounts: PropTypes.func,
  t: PropTypes.func,
};

class AccountList extends React.Component {
  /*
    Lifecycle methods
   */
  componentWillMount() {
    this.props.fetchAccounts();
  }

  /*
    Custom methods
   */
  initColumns() {
    this.columns = [
      {
        header: this.props.t('username'),
        accessor: 'username',
        filterMethod: (filter, row) =>
          row.username.toLowerCase().startsWith(filter.value.toLowerCase()),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="username" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('name'),
        accessor: 'full_name',
        filterMethod: (filter, row) =>
          row.full_name.toLowerCase().startsWith(filter.value.toLowerCase()),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="full_name" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('email'),
        accessor: 'email',
        filterMethod: (filter, row) =>
          row.email.toLowerCase().startsWith(filter.value.toLowerCase()),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="email" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('time_created'),
        accessor: 'time_created',
        render: row => dateFromISO(row.value),
        filterRender: ({ filter, onFilterChange }) => (
          <DateRangeFilterField
            name="time_created"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
        filterMethod: (filter, row) => {
          if (!filter.value) return true;
          const startDate = filter.value.startDate.startOf('day');
          const endDate = filter.value.endDate.endOf('day');
          const rowDate = moment(row.time_created);

          return rowDate.isAfter(startDate) && rowDate.isBefore(endDate);
        },
      },
      {
        header: this.props.t('active'),
        accessor: 'active',
        className: 'centerAlign',
        render: row => (row.value ? <Done color={lightGreen500} /> : <Clear color={red300} />),
        filterRender: ({ filter, onFilterChange }) => (
          <YesNoFilterField name="active" filter={filter} onFilterChange={onFilterChange} />
        ),
        filterMethod: (filter, row) => row.active === filter.value,
      },
      {
        header: this.props.t('role'),
        accessor: 'role',
        render: row => this.props.t(row.value),
        filterRender: ({ filter, onFilterChange }) => (
          <EnumSelectFilterField
            values={ACCOUNT_ROLE_ENUMS}
            name="state"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
      },
    ];
  }

  fetchData = () => {
    this.props.fetchAccounts();
  };

  itemEdit = (id) => {
    browserHistory.push(`/accounts/modify/${id}`);
  };

  itemCreate = () => {
    browserHistory.push('/accounts/new');
  };

  render() {
    this.initColumns();

    let data = [];
    if (this.props.accounts) {
      data = Object.values(this.props.accounts);
    }

    return (
      <CommonTable
        title={this.props.t('account_list')}
        data={data}
        onItemEdit={this.itemEdit}
        onItemCreate={this.itemCreate}
        loading={this.props.loading}
        columns={this.columns}
        onChange={this.fetchData}
      />
    );
  }
}

AccountList.defaultProps = defaultProps;
AccountList.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    loading: state.accounts.fetching,
    accounts: state.accounts.entities,
    translate: getTranslate(state.locale),
  };
}

const extended = translate(['translations'], { i18n })(AccountList);
export default connect(mapStateToProps, accountActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/AccountList.js